/*
* Cookie module
*/

export const cookieSet = (name, value, options) => {
    if(Number.isInteger(options)) {
        const expires = new Date();
        expires.setTime(expires.getDate() + (options * 3600 * 100));
        options = { expires: options };
    }
    options = {
        path: "/",
        // secure: true,
        samesite: 'strict',
        ...options
    };
    if(options.expires instanceof Date) options.expires = options.expires.toUTCString();
    let cookieString = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    Object.entries(options).forEach(([key, val]) => {
        cookieString += `; ${key}`;
        if(val !== true) cookieString += `=${val}`;
    });
    document.cookie = cookieString;
};

export const cookieGet = name => {
    let matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
    );

    return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const cookieCheck = name => {
    console.debug('Cookie Check')
    return cookieGet(name);
};
